import React from 'react'

import { createStyles, makeStyles, Theme } from '../../themes/ThemeProvider'
import Checkbox from '../controls/Checkbox'
import { TableRow, TableCell, TableSortLabel } from './Table'

export interface HeadTableCell {
  valueName: string
  label: string
  isNotSortAble?: boolean
}

export type Order = 'asc' | 'desc'

export type HeadTableSortLabelProps = {
  headCells: HeadTableCell[]
  order: Order
  orderBy: string
  onRequestSort: (property: string) => void
  isCheckboxShow?: boolean
  onSelectAllList?(): void
  selectAllList?: boolean
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    headRow: {
      '& .MuiTableCell-head': {
        ...theme.typography.subtitle1,
        color: theme.palette.grey[900]
      },
      height: 88
    }
  })
)

export function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1
  }
  if (b[orderBy] > a[orderBy]) {
    return 1
  }
  return 0
}

export function getComparator<T>(
  order: Order,
  orderBy: keyof T
): (a: T, b: T) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

export function stableSort<T>(array: any[], comparator: (a: T, b: T) => any) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, any])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })
  return stabilizedThis.map((el) => el[0])
}

export const HeadTableSortLabel: React.FC<HeadTableSortLabelProps> = (props) => {
  const {
    headCells,
    isCheckboxShow,
    order,
    orderBy,
    onRequestSort,
    onSelectAllList,
    selectAllList
  } = props
  const classes = useStyles()

  const createSortHandler = (property: string) => () => {
    onRequestSort(property)
  }

  return (
    <TableRow className={classes.headRow}>
      {isCheckboxShow && (
        <TableCell>
          <Checkbox onClick={onSelectAllList} checked={selectAllList} />
        </TableCell>
      )}
      {headCells.map((headCell, index) => (
        <TableCell
          key={index}
          sortDirection={orderBy === headCell.valueName ? order : false}
        >
          {headCell.isNotSortAble ? (
            headCell.label
          ) : (
            <TableSortLabel
              active={orderBy === headCell.valueName}
              direction={orderBy === headCell.valueName ? order : 'asc'}
              onClick={createSortHandler(headCell.valueName)}
            >
              {headCell.label}
            </TableSortLabel>
          )}
        </TableCell>
      ))}
    </TableRow>
  )
}